// extracted by mini-css-extract-plugin
module.exports = {"price-value":"LoadingPrice_price-value__2bUT-","spinner":"LoadingPrice_spinner__3WZ5W"};